import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import enTranslation from './locales/en.json';
import viTranslation from './locales/vi.json';
import jaTranslation from './locales/ja.json';
import idTranslation from './locales/id.json';
import bnTranslation from './locales/bn.json';
import koTranslation from './locales/ko.json';
import kmTranslation from './locales/km.json';
import ptTranslation from './locales/pt.json';
import zhTranslation from './locales/zh.json';
import filTranslation from './locales/fil.json';

const resources = {
    en: {
        translation: enTranslation,
    },
    vi: {
        translation: viTranslation,
    },
    ja: {
        translation: jaTranslation,
    },
    id: {
        translation: idTranslation,
    },
    bn: {
        translation: bnTranslation,
    },
    ko: {
        translation: koTranslation,
    },
    km: {
        translation: kmTranslation,
    },
    pt: {
        translation: ptTranslation,
    },
    zh: {
        translation: zhTranslation,
    },
    fil: {
        translation: filTranslation,
    },
};
i18n
    // loads translations from  server
    .use(Backend)
    // detect user language
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    .init({
        debug: true,
        lng: 'vi',
        fallbackLng: 'vi',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources,
        // backend: {
        //   // for all available options read the backend's repository readme file
        //   loadPath: '/locales/{{lng}}/{{ns}}.json',
        // },
    });

export default i18n;
